import SessionManager from "./SessionManager";

/**
 * Returns headers to attach X-Session-Id for journey correlation.
 * Use when building request headers for API calls.
 * Never throws – returns {} on error so it cannot break request flow.
 */
export function getJourneyHeaders() {
  try {
    const sessionId = SessionManager.getSessionId();
    return sessionId ? { "X-Session-Id": sessionId } : {};
  } catch {
    return {};
  }
}
